// extracted by mini-css-extract-plugin
export var contacts = "Contacts-module--contacts--3rFuK";
export var contacts__list = "Contacts-module--contacts__list--2qLtE";
export var contacts__list_item = "Contacts-module--contacts__list_item--35M_i";
export var contacts__list_item_link = "Contacts-module--contacts__list_item_link--tIVfP";